import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'neurokin_recently_viewed';
const MAX_ITEMS = 8;

export function useRecentlyViewed() {
  const [recentlyViewed, setRecentlyViewed] = useState([]);

  // Load from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        setRecentlyViewed(JSON.parse(stored));
      }
    } catch (e) {
      console.error('Error loading recently viewed:', e);
    }
  }, []);

  // Add a product to recently viewed
  const addToRecentlyViewed = useCallback((product) => {
    if (!product?.id) return;

    setRecentlyViewed((prev) => {
      // Remove if already exists (we'll add it to the front)
      const filtered = prev.filter((p) => p.id !== product.id);
      
      // Add to front, keep only essential data
      const newItem = {
        id: product.id,
        name: product.name,
        price: product.price,
        category: product.category,
        images: product.images?.slice(0, 1) || [],
        store_name: product.store_name,
        viewedAt: Date.now()
      };
      
      const updated = [newItem, ...filtered].slice(0, MAX_ITEMS);
      
      // Save to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      } catch (e) {
        console.error('Error saving recently viewed:', e);
      }
      
      return updated;
    });
  }, []);

  // Clear all recently viewed
  const clearRecentlyViewed = useCallback(() => {
    setRecentlyViewed([]);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('Error clearing recently viewed:', e);
    }
  }, []);

  return {
    recentlyViewed,
    addToRecentlyViewed,
    clearRecentlyViewed
  };
}
